import { createSlice } from "@reduxjs/toolkit";

export const ProcessingSlice = createSlice({
    name:'processing',
    initialState: {
        show: false,
        message: ""
    },
    reducers: {
        showProcessing: (state, action) => {
            console.log("showprocessing - ", action.payload.message);
            return {
                ...state,
                show: true,
                message: action.payload.message
            }
        },
        hideProcessing: (state, action) => {
            console.log("hideprocessing - state: ", state);
            return {
                ...state,
                show: false,
                message: ""
            }
        }
    }
})

export const { showProcessing, hideProcessing } = ProcessingSlice.actions

export default ProcessingSlice.reducer